import styled from 'styled-components';
import OverviewCard from './components/OverviewCard';
import {
  UserGroup,
  SuccessRate,
  TestCategory,
  TestIntegrity,
} from '../../assets/images/svgs';
import { IOverviewProps } from './overview-models/overview.Interface';

const Overview = ({ data }: IOverviewProps) => {
  return (
    <Container>
      <OverviewCard
        icon={<UserGroup />}
        value={data?.registeredTestTakers || '0'} 
        desc="Registered Test Takers"
      />
      <OverviewCard
        icon={<SuccessRate />}
        value={data?.testSuccessRate || '0'}
        desc="Total Test Success Rate"
        />
      <OverviewCard
        icon={<TestCategory />}
        value={data?.upcomingTest || '0'}
        desc="Upcoming Tests"
        />
      <OverviewCard
        icon={<TestIntegrity />}
        value={data?.testIntegrity || '0'}
        desc="Test Integrity"
      />
    </Container>
  );
};

export default Overview;

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 10px;
  width: 100%;
  grid-gap: 15px;
  place-content: center;
`;
